export default __webpack_public_path__ + "static/media/walkthrough-arrow.1b64aeca.svg";